module.exports = __webpack_public_path__ + "img/spjc.10e51375.png";